export default function getGapYSm(value) {
  switch (value) {
    case 0.5:
      return "sm:gap-y-0.5";
    case 1:
      return "sm:gap-y-1";
    case 2:
      return "sm:gap-y-2";
    case 3:
      return "sm:gap-y-3";
    case 4:
      return "sm:gap-y-4";
    case 5:
      return "sm:gap-y-5";
    case 6:
      return "sm:gap-y-6";
    case 7:
      return "sm:gap-y-7";
    case 8:
      return "sm:gap-y-8";
    case 9:
      return "sm:gap-y-9";
    case 10:
      return "sm:gap-y-10";
    case 12:
      return "sm:gap-y-12";
    case 14:
      return "sm:gap-y-14";
    case 16:
      return "sm:gap-y-16";
    case 20:
      return "sm:gap-y-20";
    case 24:
      return "sm:gap-y-24";
    case 28:
      return "sm:gap-y-28";
    case 32:
      return "sm:gap-y-32";
    case 36:
      return "sm:gap-y-36";
    case 40:
      return "sm:gap-y-40";
    case 44:
      return "sm:gap-y-44";
  }
}
